import { render, staticRenderFns } from "./noticeExpressList.vue?vue&type=template&id=183d9603&scoped=true"
import script from "./noticeExpressList.vue?vue&type=script&lang=js"
export * from "./noticeExpressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d9603",
  null
  
)

export default component.exports